import { __ } from '@wordpress/i18n';

document.addEventListener('DOMContentLoaded', () => {

    const searchComponent = document.querySelector('.main-header-lateral__search');

    if(searchComponent){
        const searchForm = searchComponent.querySelector('#searchform');
        const input = searchForm.querySelector('input[type="text"]');
        input.placeholder = __( 'Search', 'hacklabr' );
    }

    // searchComponent = document.querySelectorAll('.search-component')

    // if (searchComponent) {
    //     searchComponent.forEach((elem) => {
    //         input = elem.querySelector('input[type="text"]')

    //         input.addEventListener('focusout', (e) => {
    //             input.classList.toggle('open-input')
    //         })

    //         input.addEventListener('focusin', (e) => {
    //             input.classList.toggle('open-input')
    //         })
    //     })
    // }
})
